/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Deutschlandticketbestellt2Inputs */



/**

* @param {_Field_Deutschlandticketbestellt2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_deutschlandticketbestellt2 = /** @type {((inputs?: _Field_Deutschlandticketbestellt2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Deutschlandticketbestellt2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Deutschland Ticket Bestellt")
});
export { _field_deutschlandticketbestellt2 as "_field_deutschlandTicketBestellt" }